import { AccessoriesSizeGuide } from '@components/AccessoriesSizeGuide/AccessoriesSizeGuide'
import { ApparelSizeGuide } from '@components/ApparelSizeGuide/ApparelSizeGuide'
import { ShoeSizeGuide } from '@components/ShoeSizeGuide/ShoeSizeGuide'
import type { SizeGuideModalProps } from '@velasca/types'
import { Content, StyledModal } from './SizeGuideModal.styles'

export const SizeGuideModal = (
  props: SizeGuideModalProps,
): JSX.Element | null => {
  const { type } = props

  if (type === 'accessories') {
    const { isModalOpen, setIsModalOpen, ...rest } = props

    return (
      <StyledModal open={isModalOpen} onOpenChange={setIsModalOpen}>
        <Content>
          <AccessoriesSizeGuide {...rest} />
        </Content>
      </StyledModal>
    )
  }
  if (type === 'shoes') {
    const { isModalOpen, setIsModalOpen, ...rest } = props

    return (
      <StyledModal open={isModalOpen} onOpenChange={setIsModalOpen}>
        <Content>
          <ShoeSizeGuide {...rest} />
        </Content>
      </StyledModal>
    )
  }

  if (type === 'apparel') {
    const { isModalOpen, setIsModalOpen, ...rest } = props

    return (
      <StyledModal open={isModalOpen} onOpenChange={setIsModalOpen}>
        <Content>
          <ApparelSizeGuide {...rest} />
        </Content>
      </StyledModal>
    )
  }

  return null
}
